import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "./../../components/card/card.jsx";
import "react-quill/dist/quill.snow.css";
import { useParams, useSearchParams } from "react-router-dom";
import { machineProfile, sensor } from "../../api";
import LiveChart from "./LiveChart";
import {
  renderImage,
  printDate,
  printLocation,
  formatDateOnly,
} from "../../utils/helper";
import { useAuth } from "../../contexts/AuthContext";
import ImageViewer from "../../components/ImageViewer";
import LoadingIndicator from "../../components/LoadingIndicator";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DataTable from "react-data-table-component";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import { startOfDay, endOfDay, subMonths, isAfter } from "date-fns";


function PageMachineProfile() {
  const { selectAnnotation, refreshAnnotation } = useDashboardContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const [allAnnotation, setAllAnnotation] = useState([]);
  const [selectedAnnotation, setSelectedAnnotation] = useState(null);
  const { getLocationName, email } = useAuth();
  const { machineId } = useParams();
  const [machine, setMachine] = useState(null);
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState([]);
  const [key, setKey] = useState("tab0");
  const [filteredDate, setFilteredDate] = useState(null);

  useEffect(() => {
    if (machine) {
      const start = searchParams.get("start");
      const end = searchParams.get("end");
      const machine_element = searchParams.get("machine_element");
      const feature_name = searchParams.get("feature_name");
      const feature_value = searchParams.get("feature_value");
      const notif_type = searchParams.get("notif_type");

      const listSensor = getSensors();
      const index = listSensor.findIndex((s) => s.machine_element_name === machine_element);
      if (index !== -1) {
        setFilteredDate({ startDate: start, endDate: end });
        setKey("tab" + index);
      } else {
        setFilteredDate({ startDate: startOfDay(subMonths(new Date(), 1)), endDate: endOfDay(new Date()) });
        setKey("tab0");
      }
    }
  }, [machine]);

  useEffect(() => {
    if (machine) {
      const locationName = [];
      function generateLocation(location) {
        locationName.push(location.location_name);
        if (location.parent_location) {
          generateLocation(location.parent_location);
        }
      }

      generateLocation(machine.location);
      setLocations(locationName.reverse());
    }
  }, [machine]);
  const getMachine = async () => {
    try {
      setLoading(true);
      const res = await machineProfile.getOne(machineId);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setMachine(data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  const getMachineElementName = (d) => {
    const words = d.machine_element_name?.trim().split(" ");
    const lastWord = words[words.length - 1];
    console.log({ d })
    if (lastWord !== 'DE' || lastWord !== 'NDE') {
      const date = new Date("2025-08-19")
      if (isAfter(new Date(d.date), date)) {
        if (d.machine_element_position === 'drive_end') {
          return d.machine_element_name + " DE"
        }
        if (d.machine_element_position === 'non_drive_end') {
          return d.machine_element_name + " NDE"
        }
      }
    }
    return d.machine_element_name
  }
  useEffect(() => {
    getMachine();
    getAnnotation();
  }, []);

  useEffect(() => {
    getAnnotation();
  }, [refreshAnnotation]);

  const getAnnotation = async () => {
    const result = await sensor.getAnnotationMachine({
      machine_id: machineId,
    });
    if (result.ok) {
      const body = await result.json();
      let data = body.data;
      setAllAnnotation(data);
    }
  };

  const getSensors = () => {
    const sensors = [];
    if (machine && machine.machine_elements) {
      machine.machine_elements.map((me) => {
        if (me.deployments) {
          me.deployments.map((d) => {
            let sensor = d.sensor;
            sensor.machine_element_name = me.machine_element_name;
            sensor.machine_element_id = me.id;
            sensor.machine_element_position = d.machine_element_position;
            sensor.date = d.deployed_on;
            sensor.deployments_id = d.id;
            sensor.attachments = me.attachments;
            sensors.push(sensor);
          });
        }
      });
    }
    return sensors;
  };
  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div>
              <table className="table table-sm">
                <tr>
                  <td>Chart Type</td>
                  <td>:</td>
                  <td>{data.chart_type}</td>
                </tr>
                <tr>
                  <td>Timestamp</td>
                  <td>:</td>
                  <td>{data.timestamp}</td>
                </tr>
                <tr>
                  <td>Updated By</td>
                  <td>:</td>
                  <td>{data.updated_by}</td>
                </tr>
                <tr>
                  <td>Type</td>
                  <td>:</td>
                  <td>{data.annotation_type}</td>
                </tr>
                <tr>
                  <td>Annotation</td>
                  <td>:</td>
                  <td>{data.annotation}</td>
                </tr>
                <tr>
                  <td>Element</td>
                  <td>:</td>
                  <td>
                    {data.deployment?.machine_element?.machine_element_name}
                  </td>
                </tr>
              </table>
              <button
                onClick={() => viewAnnotation(data)}
                className="btn mt-3 btn-sm btn-outline-theme"
              >
                View Annotation
              </button>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  const viewAnnotation = (data) => {
    const sensorId = data?.deployment?.sensor_id;
    const listSensor = getSensors();
    const filter = listSensor.findIndex((s) => s.internal_id === sensorId);

    if (filter !== -1) {
      setKey("tab" + filter);
      const sensorData = listSensor[filter];
      setSelectedAnnotation(data);
      selectAnnotation(data);
    }
  };

  const columns = [
    {
      name: "Type",
      width: "70px",
      selector: (row) => row.annotation_type,
    },
    {
      name: "Timestamp",
      selector: (row) => row.timestamp,
    },
    {
      name: "Element",
      selector: (row) => row.deployment?.machine_element?.machine_element_name,
    },
  ];

  return (
    <div>
      <LoadingIndicator open={loading} />
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">MACHINE</a>
            </li>
            <li className="breadcrumb-item active">LIVE SENSOR DATA</li>
          </ol>
          <h1 className="page-header mb-0">Live Sensor Data</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-4">
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Machine Information
            </CardHeader>
            <CardBody>
              <div className="row">
                <div className="col-lg-12 col-sm-12 mb-2">
                  <Card>
                    <CardBody style={{ padding: "7px" }}>
                      <ImageViewer src={machine?.attachments?.filePhoto} />
                    </CardBody>
                    <CardFooter className="text-theme fw-bold text-center">
                      {machine?.machine_name}
                    </CardFooter>
                  </Card>
                </div>
                <div className="col-lg-12 col-sm-12">
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Machine Type</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {machine?.machine_type?.name}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Brand</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {machine?.machine_brand?.trim() || "-"}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Date of Purchase</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {printDate(machine?.purchase_date)}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Warranty Until</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {printDate(machine?.warranty_date)}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>ISO Standard</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {machine?.iso_standard || "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Machine Location
            </CardHeader>
            {email?.includes("demokit") ? (
              <CardBody className="card-body pb-2">
                <div>
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div> Plant</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        Groundup Facility
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                </div>
              </CardBody>
            ) : (
              <CardBody className="card-body pb-2">
                {locations.map((l, index) => {
                  return (
                    <div key={index}>
                      <div className="d-flex">
                        <div className="flex-1 d-flex">
                          <div> {getLocationName(index)}</div>
                          <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                            {printLocation(l)}
                          </span>
                        </div>
                      </div>
                      <hr style={{ margin: "0.3rem 0" }} />
                    </div>
                  );
                })}
              </CardBody>
            )}
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Machine Operation
            </CardHeader>
            <CardBody className="card-body pb-2">
              <div className="d-flex">
                <div className="flex-1 d-flex">
                  <div>Operating Hour</div>
                  <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                    {machine ? machine.start_operating_hour : ""} -{" "}
                    {machine ? machine.end_operating_hour : ""}
                  </span>
                </div>
              </div>
              <hr style={{ margin: "0.3rem 0" }} />
              <div className="d-flex">
                <div>
                  <div>Sensor Added</div>
                  <ul>
                    {getSensors().map((s, index) => (
                      <li key={index}>
                        {s.sensor_serial_number} - {getMachineElementName(s)}{" "}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </CardBody>
          </Card>
          {allAnnotation.length ? (
            <Card>
              <CardHeader>
                <div>Annotation</div>
              </CardHeader>
              <CardBody>
                <DataTable
                  highlightOnHover
                  expandableRows
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  rowsPerPageOptions={[]} // to remove the rows per page
                  expandableRowsComponent={ExpandedComponent}
                  theme="dark"
                  columns={columns}
                  data={allAnnotation}
                  pagination
                />
              </CardBody>
            </Card>
          ) : null}
        </div>
        <div className="col-lg-8">
          {filteredDate && <Card className="mb-4">
            <CardHeader>Live Sensor Data</CardHeader>
            <CardBody>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
              >
                {getSensors().map((item, index) => {
                  return (
                    <Tab
                      eventKey={"tab" + index}
                      title={getMachineElementName(item)}
                    >
                      {/*        /!*only render if key are active*!/*/}
                      {key == "tab" + index && (
                        <LiveChart
                          filteredDate={filteredDate}
                          sensorData={item}
                          machineId={machineId}
                          machineDetail={machine}
                        />
                      )}
                    </Tab>
                  );
                })}
              </Tabs>
            </CardBody>
          </Card>}
        </div>
      </div>
    </div>
  );
}

export default PageMachineProfile;
